import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAllEditorialMedia,
  insertEditorialMedia,
  editEditorialMedia,
  deleteEditorialMedia,
  fetchAllEditorialSliders
} from './EditorialThunks';

// Slice
const editorialSlice = createSlice({
  name: 'editorial',
  initialState: {
    fetchSliderPending: false,
    sliderList: null,
    sliderPagination: null,
    fetchSliderRejected: null,
      
    fetchEditorialPending: false,
    editorialList: null,
    pagination: null,
    fetchEditorialRejected: null,

    insertEditorialPending: false,
    insertEditorialFulfilled: null,
    insertEditorialRejected: null,

    editEditorialFulfilled: null,
    editEditorialRejected: null,
    editEditorialPending: false,

    deleteEditorialPending: false,
    deleteEditorialFulfilled: false,
    deleteEditorialRejected: null,

    status: 'idle',
    error: null,
  },
  reducers: {
    resetInsertEditorial: (state) => {
      state.insertEditorialPending = false;
      state.insertEditorialFulfilled = null;
      state.insertEditorialRejected = null;
    },
    resetEditEditorial: (state) => {
      state.editEditorialFulfilled = null;
      state.editEditorialRejected = null;
      state.editEditorialPending = false;
    },
    resetDeleteEditorial: (state) => {
      state.deleteEditorialFulfilled = false;
      state.deleteEditorialRejected = null;
      state.deleteEditorialPending = false;
    },
  },
  extraReducers: (builder) => {
    // Fetch Editorial Media
    builder
      .addCase(fetchAllEditorialMedia.pending, (state) => {
        state.fetchEditorialPending = true;
        state.fetchEditorialRejected = null;
      })
      .addCase(fetchAllEditorialMedia.fulfilled, (state, action) => {
        state.fetchEditorialPending = false;
        console.log('Editorial API Response:', action.payload);
      
        if (action.payload?.pagination?.page == 1) {
          state.editorialList = action.payload.data;
        } else {
          console.log('Appending new items:', action.payload.data);
          action.payload.data.forEach((item) => {
            if (!state.editorialList.some(existingItem => existingItem._id === item._id)) {
              state.editorialList.push(item);
            }
          });
        }
        state.pagination = action.payload.pagination;
        console.log('Updated pagination:', state.pagination);
      })
      .addCase(fetchAllEditorialMedia.rejected, (state, action) => {
        state.fetchEditorialPending = false;
        state.fetchEditorialRejected = action.payload;
      })

      // Insert Editorial Media
      .addCase(insertEditorialMedia.pending, (state) => {
        state.insertEditorialPending = true;
        state.insertEditorialFulfilled = null;
        state.insertEditorialRejected = null;
      })
      .addCase(insertEditorialMedia.fulfilled, (state, action) => {
        state.insertEditorialPending = false;
        state.insertEditorialFulfilled = action.payload;
      })
      .addCase(insertEditorialMedia.rejected, (state, action) => {
        state.insertEditorialPending = false;
        state.insertEditorialRejected = action.payload;
      })

      // Edit Editorial Media
      .addCase(editEditorialMedia.pending, (state) => {
        state.editEditorialPending = true;
        state.editEditorialFulfilled = null;
        state.editEditorialRejected = null;
      })
      .addCase(editEditorialMedia.fulfilled, (state, action) => {
        state.editEditorialPending = false;
        state.editEditorialFulfilled = action.payload;
      })
      .addCase(editEditorialMedia.rejected, (state, action) => {
        state.editEditorialPending = false;
        state.editEditorialRejected = action.payload;
      })

      // Delete Editorial Media
      .addCase(deleteEditorialMedia.pending, (state) => {
        state.deleteEditorialPending = true;
      })
      .addCase(deleteEditorialMedia.fulfilled, (state, action) => {
        state.deleteEditorialPending = false;
        state.deleteEditorialFulfilled = true;
      })
      .addCase(deleteEditorialMedia.rejected, (state, action) => {
        state.deleteEditorialPending = false;
        state.deleteEditorialRejected = action.payload;
      }).addCase(fetchAllEditorialSliders.pending, (state) => {
        state.fetchSliderPending = true;
        state.fetchSliderRejected = null;
      })
      .addCase(fetchAllEditorialSliders.fulfilled, (state, action) => {
        state.fetchSliderPending = false;
        state.sliderList = action.payload.data;
        state.sliderPagination = action.payload.pagination;
      })
      .addCase(fetchAllEditorialSliders.rejected, (state, action) => {
        state.fetchSliderPending = false;
        state.fetchSliderRejected = action.payload;
      })
  },
});

export const { resetInsertEditorial, resetEditEditorial, resetDeleteEditorial } = editorialSlice.actions;

export default editorialSlice.reducer;
